import { render, staticRenderFns } from "./ReferralList.vue?vue&type=template&id=a1c1fce0&scoped=true&"
import script from "./ReferralList.vue?vue&type=script&lang=js&"
export * from "./ReferralList.vue?vue&type=script&lang=js&"
import style0 from "./ReferralList.vue?vue&type=style&index=0&id=a1c1fce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c1fce0",
  null
  
)

export default component.exports